/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-01-25 17:53:42
 *
 *******************************************************/

import _ from 'lodash';
import React, { Component } from 'react';
import { Page, Layout, PageActions } from '@shopify/polaris';
import { connect } from 'react-redux';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import MainMenu from 'src/components/containers/main-menu';
import DidYouKnow from 'src/components/views/sync/did-you-know.setting';
import { URL } from 'src/constants/links';

import * as syncActions from 'actions/sync-actions';
import * as CollectionActions from 'actions/filter-tree/collection-actions';

import SyncPriority from 'src/components/views/sync/v2/SyncPriority';
import RouteLeavingGuard from 'src/components/views/common/handle-leave/route-leaving-guard';
import history from 'src/routes/history';
import TitleHelp from 'src/components/views/common/title-help';

type Props = {};

type State = {
  collections: Array<{ value: string, label: string }>,
  isTriggerChange: boolean
};

type ComposedProps = Props & WithI18nProps;

class SyncSetting extends Component<ComposedProps, State> {
  state = {
    collections: [],
    isTriggerChange: false
  };

  componentDidMount() {
    const { getAllCollections } = this.props;
    getAllCollections();
  }

  componentWillReceiveProps(nextProps: ComposedProps) {
    if (!this.props.updateSyncPriorityError && nextProps.updateSyncPriorityError) {
      this.setState({ isTriggerChange: true });
    }
  }

  onSave = () => {
    const { updateSyncCollectionPriority } = this.props;
    const { collections } = this.state;
    this.setState({ isTriggerChange: false });
    updateSyncCollectionPriority(collections.filter(i => i.value));
  };

  onUpdate = collections => {
    this.setState({ collections });
  };

  setTriggerUpdate = isTriggerChange => {
    this.setState({ isTriggerChange });
  };

  render() {
    const { isTriggerChange } = this.state;
    let {
      i18n,
      allCollections,
      prioritizedCollections,
      collectionsSuccess,
      updateSyncPriorityLoading
    } = this.props;

    return (
      <div className="BC-Page BC-Page__Sync">
        <MainMenu menuId="menu-settings-sync-settings" />
        <Page
          title={i18n.translate('AdminHTML.Sync.Sync.pageTitle_Setting')}
          primaryAction={{
            content: i18n.translate('AdminHTML.Common.Action.save'),
            disabled: !isTriggerChange,
            onAction: this.onSave,
            loading: updateSyncPriorityLoading
          }}>
          <TitleHelp i18n={i18n} hrefUserManual={URL['SyncSettingDoc']} />
          <div className="sync-v2-wrapper">
            <Layout>
              <Layout.Section>
                <div className="BC-Container__Notifications">
                  {/* Did you know? */}
                  <DidYouKnow />
                </div>
              </Layout.Section>
              <Layout.Section>
                <SyncPriority
                  allCollections={allCollections}
                  prioritizedCollections={prioritizedCollections}
                  onUpdate={this.onUpdate}
                  collectionsSuccess={collectionsSuccess}
                  setTriggerUpdate={this.setTriggerUpdate}
                />
              </Layout.Section>
            </Layout>
          </div>
          <PageActions
            primaryAction={{
              content: i18n.translate('AdminHTML.Common.Action.save'),
              disabled: !isTriggerChange,
              onAction: this.onSave,
              loading: updateSyncPriorityLoading
            }}
          />
          {/* This modal is used for when click any element on this page, but route not change */}
          {/* <ConfirmLeaveModal
            active={activeModalConfirmLeavePage}
            handleCancel={this.closeModal}
            handleDiscard={this.handleDiscard}
          /> */}

          {/* This modal is used for when click any link on this page, the route will change */}
          <RouteLeavingGuard
            when={isTriggerChange}
            navigate={path => {
              history.push(path);
            }}
            isGotoWithoutShowModalConfirm={false}
            shouldBlockNavigation={isTriggerChange}
          />
        </Page>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    updateSyncPriorityLoading: _.get(state.sync, 'updateSyncPriorityLoading', false),
    updateSyncPriorityError: _.get(state.sync, 'updateSyncPriorityError', false),
    collectionsSuccess: _.get(state, 'availableCollections.success', false),
    allCollections: _.get(state.availableCollections, 'allCollections', []),
    tenantApp: _.get(state.oauth, 'tenantApp', {}),
    prioritizedCollections: _.get(
      state.oauth,
      'tenantApp.sipParams.syncCollect.prioritizedCollections',
      []
    )
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  getAllCollections: () => dispatch(CollectionActions.getAllCollections(ownProps.i18n)),
  updateSyncCollectionPriority: colections =>
    dispatch(syncActions.updateSyncCollectionPriority(colections, ownProps.i18n))
});

export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(SyncSetting));
